module.exports = __webpack_public_path__ + "res/22-img_cards_bg.6cb4fb8a08ebdfd4755e388315917881.png";